import { Injectable, QueryList } from '@angular/core';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
@Injectable({
  providedIn: 'root',
})
export class CampoDataService {
  menssagemErroCampoData: string | null = null;
  inputDataSelecionado: boolean = false;

  private getCampoData(
    campoId: string | number,
  ): HTMLInputElement & { datepickerInstance?: any } {
    const id = typeof campoId === 'number' ? `dependente-${campoId}` : campoId;
    return document.getElementById(id) as HTMLInputElement & {
      datepickerInstance?: any;
    };
  }

  campoDataSelecionado(
    event: FocusEvent,
    datepicker?: BsDatepickerDirective,
    datepickersArray?: QueryList<BsDatepickerDirective>,
    index?: number,
  ) {
    this.inputDataSelecionado = true;
    const eventoCampoData = event.target as HTMLInputElement;

    if (
      index !== undefined &&
      index !== null &&
      datepickersArray instanceof QueryList
    ) {
      const datepickerArray = datepickersArray?.toArray();
      if (datepickerArray && datepickerArray[index]) {
        const datepickerInstance = datepickerArray[index + 1];
        datepickerInstance.hide();
      }
    } else {
      if (datepicker) {
        datepicker.hide();
      }
    }

    if (eventoCampoData && eventoCampoData.value === 'Data inválida') {
      eventoCampoData.value = '';
      this.menssagemErroCampoData = null;
    }
  }

  esconderCalendario(
    datepicker?: BsDatepickerDirective,
    datepickersArray?: QueryList<BsDatepickerDirective>,
    index?: number,
  ) {
    if (
      index !== null &&
      index !== undefined &&
      datepickersArray instanceof QueryList
    ) {
      const datepickerInstances = datepickersArray.toArray();
      if (
        datepickerInstances &&
        datepickerInstances[index] &&
        this.inputDataSelecionado === true
      ) {
        datepickerInstances[index + 1].hide();
      }
      return;
    }

    if (datepicker && this.inputDataSelecionado === true) {
      datepicker.hide();
    }
  }

  mostrarCalendario(
    datepicker?: BsDatepickerDirective,
    datepickersArray?: QueryList<BsDatepickerDirective>,
    index?: number,
  ) {
    this.inputDataSelecionado = false;
    if (
      index !== null &&
      index !== undefined &&
      datepickersArray instanceof QueryList
    ) {
      const datepickerInstances = datepickersArray.toArray();
      if (datepickerInstances && datepickerInstances[index].isOpen) {
        datepickerInstances[index + 1].hide();
        return;
      } else {
        datepickerInstances[index + 1].show();
        return;
      }
    }
    if (datepicker) {
      if (datepicker.isOpen) {
        datepicker.hide();
      } else {
        datepicker.show();
      }
    }
  }

  formatarCampoData(valor: string, campoId: string | number): string {
    const elementoCampoData = this.getCampoData(campoId);
    const valorCampo = valor?.toString() ?? '';
    let valorMaiorQueHoje = new Date(valorCampo);

    if (
      (valorCampo && isNaN(Date.parse(valorCampo))) ||
      valorMaiorQueHoje > new Date()
    ) {
      this.menssagemErroCampoData = 'Data inválida';
      setTimeout(() => {
        elementoCampoData.value = 'Data inválida';
        this.menssagemErroCampoData = null;
      }, 0);
      return '';
    }

    const apenasNumeros = valorCampo.replace(/\D/g, '');

    if (apenasNumeros.length <= 2) {
      return apenasNumeros; // Apenas o dia
    } else if (apenasNumeros.length <= 4) {
      return `${apenasNumeros.slice(0, 2)}/${apenasNumeros.slice(2)}`; // Dia/Mês
    } else {
      return `${apenasNumeros.slice(0, 2)}/${apenasNumeros.slice(
        2,
        4,
      )}/${apenasNumeros.slice(4)}`; // Dia/Mês/Ano
    }
  }

  formatarCampoDataFutura(valor: string, campoId: string | number): string {
    const elementoCampoData = this.getCampoData(campoId);
    const valorCampo = valor?.toString() ?? '';

    // Verifica se é uma data válida
    if (valorCampo && isNaN(Date.parse(valorCampo))) {
      this.menssagemErroCampoData = 'Data inválida';
      setTimeout(() => {
        elementoCampoData.value = 'Data inválida';
        this.menssagemErroCampoData = null;
      }, 0);
      return '';
    }

    if (valorCampo) {
      const dataDigitada = new Date(valorCampo);
      const hoje = new Date();

      // Zera horas, minutos, segundos e milissegundos para comparar apenas as datas
      hoje.setHours(0, 0, 0, 0);
      dataDigitada.setHours(0, 0, 0, 0);

      if (dataDigitada < hoje) {
        this.menssagemErroCampoData = 'Data inválida';
        setTimeout(() => {
          elementoCampoData.value = 'Data inválida';
          this.menssagemErroCampoData = null;
        }, 0);
        return '';
      }
    }

    const apenasNumeros = valorCampo.replace(/\D/g, '');

    if (apenasNumeros.length <= 2) {
      return apenasNumeros; // Apenas o dia
    } else if (apenasNumeros.length <= 4) {
      return `${apenasNumeros.slice(0, 2)}/${apenasNumeros.slice(2)}`; // Dia/Mês
    } else {
      return `${apenasNumeros.slice(0, 2)}/${apenasNumeros.slice(
        2,
        4,
      )}/${apenasNumeros.slice(4)}`; // Dia/Mês/Ano
    }
  }
}
